import { render, staticRenderFns } from "./cube-page.vue?vue&type=template&id=4fb97186&scoped=true&"
import script from "./cube-page.vue?vue&type=script&lang=js&"
export * from "./cube-page.vue?vue&type=script&lang=js&"
import style0 from "./cube-page.vue?vue&type=style&index=0&id=4fb97186&scoped=true&lang=less&"
import style1 from "./cube-page.vue?vue&type=style&index=1&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb97186",
  null
  
)

export default component.exports